import Cookies from 'js-cookie'

// 與 BDMS 共用的 token。cookie 的 domain 設在 .nidin.shop，
// 讓 ecms、bdms 這些子網域都讀得到，任一邊登入後另一邊就不用再登入一次。
const SHARED_TOKEN_KEY = 'Nidin_bdms_token'

const COOKIE_OPTIONS = {
  path: '/',
  sameSite: 'Lax',
  // 7 天。不設的話是 session cookie，關掉瀏覽器就沒了，隔天再開就跳不過去 BDMS。
  // 每次寫入都會重新計算，所以實際上是「最後一次使用起算 7 天」。
  expires: 7,
  secure: window.location.protocol === 'https:',
  // 本機開發（localhost）不能寫 .nidin.shop 的 cookie，留空就用當前網域
  domain: window.location.hostname.indexOf('nidin.shop') !== -1 ? '.nidin.shop' : undefined
}

export function getSharedToken () {
  return Cookies.get(SHARED_TOKEN_KEY)
}

export function setSharedToken (token) {
  if (!token) return
  Cookies.set(SHARED_TOKEN_KEY, token, COOKIE_OPTIONS)
}

export function removeSharedToken () {
  Cookies.remove(SHARED_TOKEN_KEY, COOKIE_OPTIONS)
}



// WEBPACK FOOTER //
// ./src/assets/js/shared-token.js